import { ShiftFormType } from 'components/shifts/ShiftForm';

export const createShiftInitialValues: Partial<ShiftFormType> = {
  isActive: true
};
